import { applyMiddleware, compose, createStore } from 'redux';
import { thunk } from 'redux-thunk';
import rootReducer from './redux/Reducer';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'root',
  storage,
  // Optionally, you can use "whitelist" or "blacklist" to filter what parts of the state to persist.
  // whitelist: ['profile'], // Persist only the 'profile' part of the state
  // blacklist: ['isLoading'], // Exclude the 'isLoading' part from persistence
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Use the default compose function if Redux DevTools extension is not available
const composeEnhancers =
  process.env.REACT_APP_MODE === 'Production'
    ? compose(applyMiddleware(thunk))
    : // @ts-ignore
    compose(applyMiddleware(thunk), window.__REDUX_DEVTOOLS_EXTENSION__());

const store = createStore(persistedReducer, composeEnhancers);

const persistedStore = persistStore(store);

export { store, persistedStore };
